export const STORE_ID = {
  ORDERING: 'ordering',
  GIFT_CARDS: 'gift-cards'
}

export type StoreId = 'ordering' | 'gift-cards'
